export enum PeFormQuestionType {
  Input,
  Score,
  Radio
}
